import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
  providedIn: 'root'
})
export class ActivityLogService extends BaseService {
  constructor(public http: HttpClient,
              public alertService: AlertService,
              public globalService: GlobalService) {
    super(http, alertService, globalService);
  }

  getSelfActivities(data): Observable<any> {
    return this.getRequest(AppUrl.SELF_ACTIVITY_LOGS(), data);
  }

  getAllActivities(data): Observable<any> {
    return this.getRequest(AppUrl.ALL_ACTIVITY_LOGS(), data);
  }

  getExecutiveActivities(id, data): Observable<any> {
    return this.getRequest(AppUrl.ALL_ACTIVITY_LOGS(id), data);
  }
}
